import AppConfig from "../../config/AppConfig";
import FuxHTTP from "../../lib/FuxFramework/FuxHTTP";
import AuthAPI from "../AuthAPI";
import APIConfig from "../APIConfig";

export const HelpdeskAPI_Admin = {
    getChatRoom: _ => {
        return FuxHTTP.get(
            `${AppConfig.webServerUrl}/api/helpdesk/chat/get-chat-room`, {
                token: AuthAPI.getUserAccessToken()
            },
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    getMessages: (id_room, limit, cursor) => {
        return FuxHTTP.get(
            `${AppConfig.webServerUrl}/api/helpdesk/chat/get-messages`, {
                token: AuthAPI.getUserAccessToken(),
                id_room: id_room,
                limit: limit,
                cursor: cursor
            },
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    getUnreadMessages: _ => {
        return FuxHTTP.get(
            `${AppConfig.webServerUrl}/api/helpdesk/chat/get-unread-messages`, {
                token: AuthAPI.getUserAccessToken()
            },
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    setRead: _ => {
        return FuxHTTP.post(
            `${AppConfig.webServerUrl}/api/helpdesk/chat/set-read`, {
                token: AuthAPI.getUserAccessToken()
            },
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    deleteMessage: message_id => {
        return FuxHTTP.post(
            `${AppConfig.webServerUrl}/api/helpdesk/chat/delete-message`, {
                token: AuthAPI.getUserAccessToken(),
                message_id: message_id
            },
            FuxHTTP.RESOLVE_RESPONSE,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    getMediaContentUrl: (id_messaggio) => {
        return (`${AppConfig.webServerUrl}/api/helpdesk/chat/get-media-content?id_messaggio=${id_messaggio}&token=${AuthAPI.getUserAccessToken()}`);
    },
    getMediaContentPreviewUrl: (id_messaggio) => {
        return (`${AppConfig.webServerUrl}/api/helpdesk/chat/get-media-content-preview?id_messaggio=${id_messaggio}&token=${AuthAPI.getUserAccessToken()}`)
    },
    sendTextMessage: (id_room, text, attachments = [], id_messaggio_reply_to = null) => {
        const formData = new FormData();
        formData.append("id_room", id_room);
        formData.append("text", text);
        formData.append("token", AuthAPI.getUserAccessToken());
        if (id_messaggio_reply_to) formData.append("id_messaggio_reply_to", id_messaggio_reply_to);
        if (attachments) {
            attachments.map(a => {
                formData.append("attachments[]", a);
            })
        }
        return new Promise((resolve, reject) => {
            fetch(`${AppConfig.webServerUrl}/api/helpdesk/chat/send-text-message`, {
                method: 'POST',
                body: formData
            })
                .then(response => response.json())
                .then(json => {
                    json.status === FuxHTTP.STATUS_SUCCESS ? resolve(json.data) : reject(json.message);
                })
                .catch(m => {
                    console.error(m);
                    reject(null);
                });
        })
    },
    sendMessageNotification: (id_room, id_messaggio, otp) => {
        return Promise.resolve(true); //Al momento non è necessario mandare una notifica ai superadmin
        return FuxHTTP.apiPostRequestWithPromise(
            `${AppConfig.webServerUrl}/api/helpdesk/chat/send-message-notification`, {
                token: AuthAPI.getUserAccessToken(),
                id_room: id_room,
                id_messaggio: id_messaggio,
                otp: otp,
            },
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    Session: {
        setSessionRating: (message_id, session_id, rating) => {
            return FuxHTTP.post(
                `${AppConfig.webServerUrl}/api/helpdesk/sessions/set-session-rating`, {
                    token: AuthAPI.getUserAccessToken(),
                    message_id: message_id,
                    session_id: session_id,
                    rating: rating
                },
                FuxHTTP.RESOLVE_DATA,
                FuxHTTP.REJECT_MESSAGE
            );
        },
    }
};

